// Client API per /api/auth/*
// Sprint 5: login flow esteso con 2FA. La shape della risposta è una discriminated
// union su `flow` ('complete' | 'require_2fa' | 'require_2fa_setup').

import {
  LoginRequestSchema,
  LoginResponseSchema,
  Verify2faRequestSchema,
  type LoginRequest,
  type LoginResponse,
  type Verify2faRequest,
} from '@audiq/shared';
import { request } from './_request';

export async function login(data: LoginRequest): Promise<LoginResponse> {
  LoginRequestSchema.parse(data);
  const res = await request<unknown>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify(data),
  });
  return LoginResponseSchema.parse(res);
}

export async function verify2fa(data: Verify2faRequest): Promise<LoginResponse> {
  Verify2faRequestSchema.parse(data);
  const res = await request<unknown>('/api/auth/login/verify-2fa', {
    method: 'POST',
    body: JSON.stringify(data),
  });
  return LoginResponseSchema.parse(res);
}

export async function logout(): Promise<void> {
  await request('/api/auth/logout', { method: 'POST' });
}

export async function refresh(): Promise<{ ok: true }> {
  return request<{ ok: true }>('/api/auth/refresh', { method: 'POST' });
}

export interface MeResponse {
  ok: true;
  user: {
    id: string;
    email: string;
    role: 'master' | 'operator' | 'viewer';
    totp_enabled: boolean;
    must_setup_totp: boolean;
    must_change_password: boolean;
    grace_until: string | null;
  };
}

export async function me(): Promise<MeResponse> {
  return request<MeResponse>('/api/auth/me', { method: 'GET' });
}

export async function changePassword(data: {
  current_password: string;
  new_password: string;
  confirm_password: string;
}): Promise<{ ok: true }> {
  return request<{ ok: true }>('/api/auth/change-password', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
